import axios from "axios";

const queries = new URLSearchParams(window.location.search);

axios.defaults.headers.common["X-AUTH-KEOS-USER"] =
  localStorage.getItem("token") ?? queries.get("authToken") ?? "";
axios.defaults.headers.post["Content-Type"] = "application/json";

export default axios.create();
